// import { IS_SIDEBAR_OPENED, LocalStorageService  } from '../core/local-storage.service.js';

angular.module('bgDirectives', [])
  .directive('bgSplitter', function($rootScope, $timeout, RouterService) {
    return {
      restrict: 'E',
      replace: true,
      transclude: true,
      scope: {
        pos: '=',
        orientation: '@',
        name: '@'
      },
      template: '<div class="maximize split-panes {{orientation}}" ng-transclude></div>',
      controller: function($scope) {
        $scope.panes = [];
        this.addPane = function(pane) {
          if ($scope.panes.length > 1)
            throw 'splitters can only have two panes';
          $scope.panes.push(pane);
          return $scope.panes.length;
        };
        $scope.showDimensions = false;
      },
      link: function(scope, element) {
        const handler = angular.element('<div class="split-handler"></div>');
        const pane1 = scope.panes[0];
        const pane2 = scope.panes[1];
        const vertical = scope.orientation == 'vertical';
        const pane1Min = pane1.minSize || 0;
        const pane2Min = pane2.minSize || 0;

        if (pane2.hide) {
          pane1.elem.css('width', '100%');
          pane2.elem.hide();
        }

        if (pane1.hide) {
          pane2.elem.css('width', '100%');
          pane1.elem.hide();
        }

        if (pane1.hide || pane2.hide) return;

        let drag = false;
        pane1.elem.after(handler);


        // const storageSrv = new LocalStorageService();

        if (vertical) {
          let oldHeight;
          const setSplitter = function(pos, limit) {
            oldHeight = element.height();
            const height = oldHeight;
            let pane1Height = pos;
            if (limit) {
              if (pos < pane1Min) pane1Height = pane1Min;
              if (pos > height - pane2Min) pane1Height = height - pane2Min;
            }
            pane1.elem.css('height', pane1Height + 'px');
            handler.css('top', pane1Height + 'px');
            const heightHandler = handler.height();
            pane2.elem.css('top', (pane1Height + heightHandler) + 'px');
            const pane2Height = height - pane1Height - heightHandler;
            pane2.elem.css('height', pane2Height + 'px');
            // console.log(scope.name + 'Changed', pane1Height, pane2Height, scope.name);
            $rootScope.$broadcast(scope.name + 'Changed', pane1Height, pane2Height, scope.name);
          };

          const setUp = function() {
            if (!pane1.elem.height()) {
              return;
            }
            const newHeight = element.height();
            const ratio = oldHeight && newHeight ? newHeight / oldHeight : 1;
            const pos = pane1.elem.height() * ratio;
            setSplitter(pos);
          };

          scope.$on('resize', setUp);

          const pane1Initial = Math.round($('#facts-container').height() / 5 * 4);

          element.bind('mousemove', function(ev) {
            if (!drag) return;
            const bounds = element[0].getBoundingClientRect();
            let pos = ev.clientY - bounds.top;
            const maxPos = element.height() - handler.height();
            if (pos > maxPos) {
              pos = maxPos;
            }
            setSplitter(pos, true);
          });
          const togglePane2 = function(setstate) {
            const oldState = scope.showPane2;
            const newState = setstate != undefined ? setstate : !scope.showPane2;
            if (oldState == newState) return;
            scope.showPane2 = newState;
            const state = scope.showPane2;
            if (state == false) {
              scope.pane1ElemHeight = pane1.elem.height();
              setSplitter(element.height() - handler.height());
            } else {
              if (scope.pane1ElemHeight) {
                setSplitter(scope.pane1ElemHeight);
              } else {
                setSplitter(pane1Initial);
              }
            }
          };
          handler.bind('dblclick', function() {
            togglePane2();
          });
          handler.bind('click', function() {
            if (pane1.elem.height() == element.height() - handler.height()) {
              togglePane2();
            }
          });
          scope.$on('showPane2', function() {
            scope.pane1ElemHeight = $(window).height() / 2;
            togglePane2(true);
          });
          scope.$on('hidePane2', function() {
            togglePane2(false);
          });
          scope.$watch('pos', function(pos) {
            if (pos) setSplitter(pos, 0);
          });
        } else {
          // let lastPos;
          const setSplitter = function(pos, limit) {
            // if (pos === lastPos) return;
            // lastPos = pos;
            const bounds = element[0].getBoundingClientRect();
            const width = bounds.right - bounds.left;
            scope.pane1Width = pos;
            if (limit) {
              if (pos < pane1Min) scope.pane1Width = pane1Min;
              if (pos > width - pane2Min) scope.pane1Width = width - pane2Min;
            }
            pane1.elem.css('width', scope.pane1Width + 'px');
            handler.css('left', scope.pane1Width + 'px');
            pane2.elem.css('left', scope.pane1Width + handler.width() + 'px');
            scope.pane2Width = width - scope.pane1Width - handler.width();
            pane2.elem.css('width', scope.pane2Width + 'px');
            // console.log(scope.name + 'Changed', scope.pane1Width, scope.pane2Width, scope.name);
            $rootScope.$broadcast(scope.name + 'Changed', scope.pane1Width, scope.pane2Width, scope.name);
          };
          element.bind('mousemove', function(ev) {
            if (!drag) return;
            const bounds = element[0].getBoundingClientRect();
            const pos = ev.clientX - bounds.left;
            setSplitter(pos, true);
          });

          const togglePane1 = function(setState) {
            const oldState = scope.showDimensions;
            const newState = setState != undefined ? setState : !scope.showDimensions;
            if (oldState == newState) return;
            scope.showDimensions = newState;
            const state = scope.showDimensions;
            if (state == false) {
              if (pane1.elem.width()) scope.pane1ElemWidth = pane1.elem.width();
              setSplitter(0);
            } else {
              if (scope.pane1ElemWidth) setSplitter(scope.pane1ElemWidth);
            }
            RouterService.setPane(state);
          };

          handler.bind('click', function(ev) {
            // if (scope.name !== 'splitter1') return;
            if (pane1.elem.width() == 0) {
              togglePane1(true);
            }
            ev.preventDefault();
          });

          handler.bind('mousemove', function(ev) {
            if (pane1.elem.width() == 0) {
              RouterService.setPane(true);
              scope.showDimensions = true;
            }
            ev.preventDefault();
          });

          angular.element(document).on('showDimensions', function(src, state, pos) {
            if (scope.name !== 'splitter1') return;
            togglePane1(state);
            if (pos != undefined) {
              setSplitter(pos, 0);
            }
          });

          scope.$watch('pos', function(pos) {
            scope.pane1ElemWidth = pos;
            if (scope.name === 'splitter1') {
              scope.showDimensions = !RouterService.paneClose;
              if (!scope.showDimensions) {
                pos = 0;
              }
            }
            setSplitter(pos, 0);
          });

          scope.$on('resize', function() {
            setSplitter(pane1.elem.width());
          });
        }

        handler.bind('mousedown', function(ev) {
          // Fix for frame
          $('.frameOverlay').css('z-index', 2);
          drag = true;
          ev.preventDefault();
        });

        angular.element(document).bind('mouseup', function() {
          // Fix for frame
          if (!vertical) {
            // console.log(scope.name + 'Mouseup', scope.pane1Width, scope.pane2Width, scope.name);
            $rootScope.$broadcast(scope.name + 'Mouseup', scope.pane1Width, scope.pane2Width, scope.name);
          }
          $('.frameOverlay').css('z-index', -1);
          // if (drag) window.updateSize();
          drag = false;
        });

      }
    };
  })

  .directive('bgPane', function() {
    return {
      restrict: 'E',
      require: '^bgSplitter',
      replace: true,
      transclude: true,
      scope: {
        minSize: '=',
        hide: '=',
      },
      template: '<div class="split-pane{{index}}" ng-transclude></div>',
      link: function(scope, element, attrs, bgSplitterCtrl) {
        scope.elem = element;
        scope.index = bgSplitterCtrl.addPane(scope);
      }
    };
  });



// WEBPACK FOOTER //
// ./src/lib/splitter.js